import { createRoot } from 'react-dom/client';
import { getLanguage } from '$core/helpers/global';

import './style.css';

import { App } from './App';

const language = getLanguage();

const container = document.getElementById('commerce');

if (container) {
  const seoContent = document.getElementById('drupal-seo-content');
  if (seoContent) {
    seoContent.style.display = 'none';
  }

  const root = createRoot(container);
  root.render(
    <App language={language} />,
  );
}
